// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__WBOt-","heading":"Profile_heading__UdbRO","caption":"Profile_caption__REgka"};